import {createAction} from 'redux-actions';

export const GLOBAL_FAILURE = 'GLOBAL_FAILURE';
export const ERROR_STATUS   = 'ERROR_STATUS';

export const setGlobalFailure =createAction(GLOBAL_FAILURE, (error) => {
  return error
})

export const setErrorStatus = createAction(ERROR_STATUS, (status) => {
  return status
})
